// extracted by mini-css-extract-plugin
export var aircallIframe = "_jj-3";
export var fabContainer = "_jj-5";
export var fabRinging = "_jj-6";
export var loadingOverlay = "_jj-4";
export var pulse = "_jj-7";
export var widgetContent = "_jj-2";
export var widgetPanel = "_jj-0";
export var widgetPanelExpanded = "_jj-1";